import { queryOptions } from '@tanstack/react-query'
import registrationApi from 'api/registrationApi'
import _ from 'lodash'

export const queryKeys = {
  base: {
    scope: ['general', 'findLogModal'],
    entity: 'log',
  },
  lists: (params) =>
    queryOptions({
      queryKey: [queryKeys.base, params],
      queryFn: () => registrationApi.getRegistrations(params),
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: true,
      retry: false,
      select: (res) => {
        console.log('registrations:', _.get(res, 'registrations', []))
        return {
          total: _.get(res, 'total', 0),
          rows: _.get(res, 'registrations', []),
        }
      },
    }),
}
